import { render, staticRenderFns } from "./pos-ticket-tabs.vue?vue&type=template&id=3a305bcf&scoped=true&"
import script from "./pos-ticket-tabs.ts?vue&type=script&lang=ts&"
export * from "./pos-ticket-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./pos-ticket-tabs.scss?vue&type=style&index=0&id=3a305bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a305bcf",
  null
  
)

export default component.exports